<mat-menu #filterMenu="matMenu">
  <ng-template matMenuContent let-caller="caller" let-integerOnly="integerOnly">
    <div class="filter-chip-panel" (click)="$event.stopPropagation()">
      <div class="filter-chip-label">{{ 'home.filter.values' | transloco }}</div>

      <div class="filter-chip-row">
        <mat-chip-grid #chipGrid>
          @for (value of textFilterValues[caller] ?? []; track $index; let i = $index) {
            <mat-chip-row (removed)="removeTextFilterValue(caller, i)">
              {{ value }}
              <button matChipRemove type="button">
                <mat-icon>close</mat-icon>
              </button>
            </mat-chip-row>
          }
        </mat-chip-grid>

        <mat-form-field class="filter-chip-input" subscriptSizing="dynamic" [hidden]="!showChipInput[caller]">
          <input
            #chipInput
            matInput
            [type]="integerOnly ? 'number' : 'text'"
            [matChipInputFor]="chipGrid"
            (matChipInputTokenEnd)="addChipValueAndHideInput(caller, $event, integerOnly)"
            [matChipInputAddOnBlur]="true"
            autocomplete="off"
            placeholder="{{ 'home.filter.addValue' | transloco }}" />
        </mat-form-field>

        @if (!showChipInput[caller]) {
          <button class="add-chip-button" (click)="showChipInput[caller] = true; focusAfterRender(chipInput)" type="button">
            <mat-icon>add</mat-icon>
            {{ 'home.filter.addValue' | transloco }}
          </button>
        }
      </div>

      <mat-divider />

      <div class="filter-toggle-row">
        <mat-slide-toggle class="filter-mode-toggle" [checked]="filterMode[caller] === 'AND'" (change)="toggleFilterMode(caller)" (click)="$event.stopPropagation()">
          {{ (filterMode[caller] === 'AND' ? 'home.filter.andMode' : 'home.filter.orMode') | transloco }}
        </mat-slide-toggle>
      </div>

      <mat-divider />

      <div class="filter-action-row">
        <button mat-stroked-button (click)="handleFilterAction(filterMenuType.TEXT, caller, true)" type="button">
          {{ 'home.filter.removeFilter' | transloco }}
        </button>
        <button mat-raised-button color="primary" (click)="handleFilterAction(filterMenuType.TEXT, caller)" type="button">
          {{ 'home.filter.startFilter' | transloco }}
        </button>
      </div>
    </div>
  </ng-template>
</mat-menu>

<mat-menu #dateFilterMenu="matMenu">
  <ng-template matMenuContent let-caller="caller">
    <div mat-menu-item mat-filter-item [disableRipple]="true" (click)="$event.stopPropagation()">
      <mat-form-field class="filter-input">
        <mat-select placeholder="{{ 'home.filter.criterion' | transloco }}" [(value)]="searchCriterion[caller]">
          @for (criterion of dateCriteriaList; track criterion.value) {
            <mat-option [value]="criterion.value">
              {{ 'home.filter.criteriaList.' + criterion.value | transloco }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div mat-menu-item mat-filter-item [disableRipple]="true" (click)="$event.stopPropagation()">
      <mat-form-field class="filter-input">
        <mat-label>YYYY-MM-DD</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="searchValue[caller]" autocomplete="off" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="action-buttons" mat-menu-item mat-filter-item [disableRipple]="true">
      <button mat-raised-button (click)="handleFilterAction(filterMenuType.DATE, caller, true)" type="button">{{ 'home.filter.removeFilter' | transloco }}</button>
      <button mat-raised-button color="primary" (click)="handleFilterAction(filterMenuType.DATE, caller)" type="button">
        {{ 'home.filter.startFilter' | transloco }}
      </button>
    </div>
  </ng-template>
</mat-menu>

<mat-menu #checkboxFilterMenu="matMenu">
  <ng-template matMenuContent let-caller="caller" let-categories="categories">
    <div class="checkbox-filter-panel" (click)="$event.stopPropagation()">
      <div class="checkbox-filter-header">
        <div class="checkbox-filter-title">{{ 'home.filter.values' | transloco }}</div>
        @if (selectedCategories[caller]?.length ?? 0; as selectedCount) {
          <span class="checkbox-filter-badge"> {{ selectedCount }} {{ 'common.text.selected' | transloco }} </span>
        }
      </div>

      <mat-form-field class="checkbox-filter-search" subscriptSizing="dynamic">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [(ngModel)]="searchTerm[caller]" placeholder="{{ 'common.buttons.search' | transloco }}" autocomplete="off" />
      </mat-form-field>

      <div class="checkbox-filter-select-all">
        <mat-checkbox
          [checked]="isAllOptionsSelected(caller, categories, selectedCategories)"
          [indeterminate]="isOptionsIndeterminate(caller, categories, selectedCategories)"
          (change)="toggleSelectAllOptions($event.checked, categories, selectedCategories, caller)">
          {{ 'common.buttons.selectAll' | transloco }}
        </mat-checkbox>
      </div>

      <div class="checkbox-filter-list">
        @for (category of getFilteredOptions(caller, categories); track category.value) {
          <div class="checkbox-filter-item">
            <mat-checkbox [checked]="isSelected(category, selectedCategories[caller])" (change)="setSelected($event.checked, category, selectedCategories, caller)">
              {{ category.name }}
            </mat-checkbox>
          </div>
        }
      </div>
    </div>

    <mat-divider />

    <div class="filter-toggle-row">
      <mat-slide-toggle class="filter-mode-toggle" [checked]="filterMode[caller] === 'AND'" (change)="toggleFilterMode(caller)" (click)="$event.stopPropagation()">
        {{ (filterMode[caller] === 'AND' ? 'home.filter.andMode' : 'home.filter.orMode') | transloco }}
      </mat-slide-toggle>
    </div>

    <mat-divider />

    <div class="filter-action-row">
      <button mat-stroked-button (click)="handleFilterAction(filterMenuType.CHECKBOX, caller, true)" type="button">{{ 'home.filter.removeFilter' | transloco }}</button>
      <button mat-raised-button color="primary" (click)="handleFilterAction(filterMenuType.CHECKBOX, caller)" type="button">
        {{ 'home.filter.startFilter' | transloco }}
      </button>
    </div>
  </ng-template>
</mat-menu>

<mat-menu #tagFilterMenu="matMenu">
  <ng-template matMenuContent let-caller="caller" let-possibleTags="possibleTags">
    <div class="checkbox-filter-panel" (click)="$event.stopPropagation()">
      <div class="checkbox-filter-header">
        <div class="checkbox-filter-title">{{ 'home.filter.values' | transloco }}</div>
        @if (selectedTags[caller]?.length ?? 0; as selectedCount) {
          <span class="checkbox-filter-badge"> {{ selectedCount }} {{ 'common.text.selected' | transloco }} </span>
        }
      </div>

      <mat-form-field class="checkbox-filter-search" subscriptSizing="dynamic">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [(ngModel)]="searchTerm[caller]" placeholder="{{ 'common.buttons.search' | transloco }}" autocomplete="off" />
      </mat-form-field>

      <div class="checkbox-filter-select-all">
        <mat-checkbox
          [checked]="isAllOptionsSelected(caller, possibleTags, selectedTags)"
          [indeterminate]="isOptionsIndeterminate(caller, possibleTags, selectedTags)"
          (change)="toggleSelectAllOptions($event.checked, possibleTags, selectedTags, caller)">
          {{ 'common.buttons.selectAll' | transloco }}
        </mat-checkbox>
      </div>

      <div class="checkbox-filter-list">
        @for (tag of getFilteredOptions(caller, possibleTags); track tag.value) {
          <div class="checkbox-filter-item">
            <mat-checkbox [checked]="isSelected(tag, selectedTags[caller])" (change)="setSelected($event.checked, tag, selectedTags, caller)">
              {{ tag.name }}
            </mat-checkbox>
          </div>
        }
      </div>
    </div>

    <mat-divider />

    <div mat-menu-item mat-filter-item [disableRipple]="true">
      <mat-slide-toggle class="filter-mode-toggle" [checked]="filterMode[caller] === 'AND'" (change)="toggleFilterMode(caller)" (click)="$event.stopPropagation()">
        {{ (filterMode[caller] === 'AND' ? 'home.filter.andMode' : 'home.filter.orMode') | transloco }}
      </mat-slide-toggle>
    </div>
    <mat-divider />

    <div class="filter-action-row">
      <button mat-stroked-button (click)="handleFilterAction(filterMenuType.TAG, caller, true)" type="button">{{ 'home.filter.removeFilter' | transloco }}</button>
      <button mat-raised-button color="primary" (click)="handleFilterAction(filterMenuType.TAG, caller)" type="button">
        {{ 'home.filter.startFilter' | transloco }}
      </button>
    </div>
  </ng-template>
</mat-menu>

<mat-menu #multiSelectFilterMenu="matMenu">
  <ng-template matMenuContent let-caller="caller" let-categories="categories" let-translation="translation">
    <div class="multiSelect-filter" mat-menu-item [disableRipple]="false" (click)="preventEventBubbling($event)">
      <app-multi-select-with-search
        label="{{ 'home.filter.multiText.' + translation }}"
        [multiple]="true"
        [itemsToSelect]="categories"
        [selectAllValue]="selectAllValue"
        (valueChanges)="multiSelectValueChanged($event, caller)"
        [formControl]="getFormControl(caller)"
        [panelWidth]="(multiSelectFilterWidth - 32).toString() + 'px'">
      </app-multi-select-with-search>
    </div>

    <div mat-menu-item mat-filter-item [disableRipple]="true" (click)="$event.stopPropagation()">
      <mat-slide-toggle class="filter-mode-toggle" [checked]="filterMode[caller] === 'AND'" (change)="toggleFilterMode(caller)" (click)="$event.stopPropagation()">
        {{ (filterMode[caller] === 'AND' ? 'home.filter.andMode' : 'home.filter.orMode') | transloco }}
      </mat-slide-toggle>
    </div>

    <div class="action-buttons" mat-menu-item mat-filter-item [disableRipple]="true">
      <button mat-raised-button (click)="handleFilterAction(filterMenuType.MULTI_SELECT, caller, true)" type="button">{{ 'home.filter.removeFilter' | transloco }}</button>
      <button mat-raised-button color="primary" (click)="handleFilterAction(filterMenuType.MULTI_SELECT, caller)" type="button">
        {{ 'home.filter.startFilter' | transloco }}
      </button>
    </div>
  </ng-template>
</mat-menu>
